import { IApplicationState } from '../../types/redux';

const defaultState: IApplicationState['regions'] = [];

export function regionsReducer(state: IApplicationState['regions'] = defaultState): IApplicationState['regions'] {
  return state;
}
